import React from "react";
import { AlignedBoxSubTitle, AlignedBoxTitle } from "../../../../styles/texts";
import { GrayButton } from "../../../../styles/buttons";
import GrayCard from "../GreyRectangles/GreyCard";
import { UserData } from "../../../../types/responseTypes";
import { useNavigate } from "react-router-dom";

interface Pending2ndCardProps {
  userData: UserData;
}

const Pending2ndCard: React.FC<Pending2ndCardProps> = ({ userData }) => {
  const navigate = useNavigate();
  
  return (
    <GrayCard>
      <div className="text-left flex flex-col w-full h-full self-stretch justify-center p-4">
        {/* Título y subtítulo */}
        <div className="text-left flex flex-col w-full">
          <AlignedBoxSubTitle fontSize="14px">Etapa actual</AlignedBoxSubTitle>
          <AlignedBoxTitle fontSize="18px">Esperando firma</AlignedBoxTitle>
        </div>

        {/* Descripción */}
        <div className="mt-4 text-[#6D707E] text-[14px] leading-[20px]">
          Para iniciar la instalación, falta que los otros dueños de la casa firmen el contrato.
          Estaremos a la espera de la firma.
        </div>

        {/* Checkboxes */}
        <div className="mt-4 text-[#6D707E] text-[14px] leading-[20px]">
          {userData.firstName} {userData.lastName}<strong> (Tu) </strong>
        </div>

        {/* Botón */}
        <div className="mt-6 w-full text-left flex flex-col items-end">
          <GrayButton
            label="Ver próximos pasos"
            icon="rightarrow"
            w="250px"
            onClick={() => navigate("/steps")}
          />
        </div>
      </div>
    </GrayCard>
  );
};

export default Pending2ndCard;
